import { GameTemplateForm } from "./form";
import { useSnackbar } from "notistack";
import { translate } from "../../../translations";
import { useNavigate } from "react-router";
import APIclient from "../../../api-client";
import { GameTemplateParams } from "../../../api-client/game_template_module";

export default function CreateGameTemplate() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const newTemplate = {
    name: "",
    questionSet: null,
    statements: [],
    parties: [],
    ownTempo: false,
    ownArguments: false,
    skipQuestions: false,
  };

  const createGame = async (template: GameTemplateParams) => {
    await APIclient.gameTemplates.create(template);
    enqueueSnackbar(translate("teacher.gameSettings.create.successMessage"), {
      variant: "success",
    });
    navigate("/teacher");
  };

  return <GameTemplateForm template={newTemplate} submit={createGame} />;
}
